var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChecklistLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 72 72"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 32.825,
  stroke: "currentColor",
  strokeWidth: 2.85
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.85,
  d: "m20.174 35.047 10.55 10.55 21.103-19.195"
})));
export { SvgChecklistLarge as ReactComponent };